export const POSTER_MOBILE_BIG_SEEK_BAR_HEIGHT = 80;
